import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {useUser} from "./Context/UserContext";
import MainLayout from "./Components/layout/main-layout/MainLayout";
import ProjectComparer from "./App/ProjectComparer";
import LoginForm from "./App/LoginForm";
import ChangePassword from "./App/ChangePassword";
import EditProfile from "./App/EditProfile";
import Register from "./App/Register";
import RegisterSuccess from "./App/RegisterSuccess";
import RegisterVerification from "./App/RegisterVerification";
import InternalCheck2 from "./App/InternalCheck2";
import ComparisonCheck2 from "./App/ComparisonCheck2";
import {Help} from "./Components/Help";
import {Footer} from "antd/es/layout/layout";
import ReportPage from "./App/ReportPage";
import UserSettings from "./App/UserSettings";
import {useEffect} from "react";
import ApiService from "./Service/ApiService";
import LandingPage from "./App/LandingPage";
import UserDashboard from "./App/UserDashboard";
import EULA from "./App/EULA";
import AdminDashboard from "./App/AdminDashboard";
import UserProfile from "./App/UserProfile";
import ResetPasswordSend from "./App/ResetPasswordSend";
import ResetPassword from "./App/ResetPassword";
import ResetPasswordSuccess from "./App/ResetPasswordSuccess";

function PrivateRoute({children, ...rest})
{
    const {
        isAuth,
        setSettings
    } = useUser();

    const getSettings  = async () => {
        const res = await ApiService.User.UserSettings()
        if(res.success) {
            setSettings({
                settings: JSON.parse(res.data.settings),
                defaultSettings: res.data.defaultSettings,
            })
        }
    }

    useEffect(() => {
        getSettings()
    }, [])

    return (
        <Route {...rest} render={() =>
        {
            return isAuth()
                ? children
                : <Redirect to={'/app/login'} />
        }}/>
    )
}

export default function AppRouter()
{
    const {user} = useUser();

    return (
        <Router>
            <Switch>
                <Route path={'/app/login'} component={LoginForm}/>
                <Route path={'/app/register/success'} component={RegisterSuccess}/>
                <Route path={'/app/register/verification'} component={RegisterVerification}/>
                <Route path={'/app/register'} component={Register}/>
                <Route exact path={'/app/reset-password/send'}  component={ResetPasswordSend}/>
                <Route exact path={'/app/reset-password/success'}  component={ResetPasswordSuccess}/>
                <Route exact path={'/app/reset-password'}  component={ResetPassword}/>
                <Route path={'/app/eula'} component={EULA}/>
                <PrivateRoute>
                    <div style={{display: 'flex', flexDirection: 'column', alignContent: 'space-between', height: '100%'}}>
                        <MainLayout>
                            <Switch>
                                {(<Route exact path={'/app/upload-project'}  component={ProjectComparer}/>)}
                                {(<Route exact path={'/app/internal-check'}  component={InternalCheck2}/>)}
                                {(<Route exact path={'/app/comparison-check'}  component={ComparisonCheck2}/>)}
                                {(<Route exact path={'/app/report'}  component={ReportPage}/>)}
                                {(<Route exact path={'/app/help'}  component={Help}/>)}
                                {(<Route exact path={'/app/user/dashboard'}  component={UserDashboard}/>)}
                                {(<Route exact path={'/app/user/profile'}  component={UserProfile}/>)}

                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/dashboard'}  component={AdminDashboard}/>)}

                                {(<Route exact path={'/app/profile/change-password'}  component={ChangePassword}/>)}
                                {(<Route exact path={'/app/profile/settings'}  component={UserSettings}/>)}
                                {(<Route exact path={'/app/profile/edit'}  component={EditProfile}/>)}

                                {(<Route exact path={'/app'}  component={ProjectComparer}/>)}
                                {(<Route exact path={'/'}  component={UserDashboard}/>)}
                            </Switch>
                        </MainLayout>
                    </div>
                </PrivateRoute>
            </Switch>
        </Router>
    )
}

